import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsConditions = () => {
    return (
        <div className="min-h-screen bg-[#FDFCF8] flex flex-col items-center p-8 bg-grid">
            <div className="absolute top-8 left-8">
                <Link
                    to="/"
                    className="flex items-center gap-2 text-gray-500 hover:text-purple-600 font-bold transition-all group"
                >
                    <div className="w-10 h-10 rounded-full bg-white border border-gray-100 flex items-center justify-center group-hover:bg-purple-50 group-hover:border-purple-100 shadow-sm transition-all">
                        <ArrowLeft size={18} />
                    </div>
                    <span>Voltar ao início</span>
                </Link>
            </div>

            <div className="w-full max-w-3xl animate-fade-in mt-16">
                <div className="flex flex-col items-center text-center mb-10">
                    <h1 className="text-3xl font-black mb-2 font-hero">
                        Termos e Condições
                        <br />
                        (Em construção)
                    </h1>
                    <p className="text-gray-500 font-medium">
                        Última atualização: 10 de Janeiro de 2026
                    </p>
                </div>

                <div className="bg-white p-8 md:p-12 rounded-[3rem] shadow-xl border border-gray-100 prose prose-purple max-w-none">
                    <h3>1. Aceitação dos Termos</h3>
                    <p>
                        Ao acessar e usar o Sora, você concorda em cumprir e ficar vinculado aos seguintes termos e condições de uso. Se você não concordar com estes termos, não deverá usar nossos serviços.
                    </p>

                    <br />

                    <h3>2. Descrição do Serviço</h3>
                    <p>
                        O Sora é uma plataforma destinada a auxiliar professores na organização e planejamento de suas aulas. Nós nos reservamos o direito de modificar ou descontinuar o serviço a qualquer momento, com ou sem aviso prévio.
                    </p>

                    <br />

                    <h3>3. Uso da Conta</h3>
                    <p>
                        Você é responsável por manter a confidencialidade de sua conta e senha. Você concorda em notificar imediatamente o Sora sobre qualquer uso não autorizado de sua conta.
                    </p>

                    <br />

                    <h3>4. Propriedade Intelectual</h3>
                    <p>
                        Todo o conteúdo presente no Sora, incluindo textos, gráficos, logotipos e software, é propriedade do Sora ou de seus licenciadores e está protegido por leis de direitos autorais.
                    </p>

                    <br />

                    <h3>5. Privacidade</h3>
                    <p>
                        Sua privacidade é importante para nós. Nossa Política de Privacidade explica como coletamos, usamos e protegemos suas informações pessoais.
                    </p>

                    <br />

                    <h3>6. Limitação de Responsabilidade</h3>
                    <p>
                        O Sora não será responsável por quaisquer danos diretos, indiretos, incidentais ou consequenciais resultantes do uso ou da incapacidade de usar o serviço.
                    </p>

                    <br />

                    <h3>7. Alterações nos Termos</h3>
                    <p>
                        Podemos revisar estes termos de tempos em tempos. As alterações entrarão em vigor assim que forem publicadas nesta página.
                    </p>

                    <br />

                    <h3>8. Contato</h3>
                    <p>
                        Se você tiver dúvidas sobre estes termos, entre em contato conosco através do nosso suporte.
                    </p>
                </div>

                <p className="mt-12 text-center text-gray-400 text-sm font-medium">
                    © 2026 Sora — Todos os direitos reservados.
                </p>
            </div>
        </div>
    );
};

export default TermsConditions;
